import {axios} from "@/api/config";
// 查询检查项列表
export function listItem(params) {
  return axios.get('/tbBaseCheckItem/list', params, true);
}

// 查询检查项详细
export function getItem(id) {
  return axios.get(`/tbBaseCheckItem/${id}`, id, true)
}

// 新增检查项
export function addItem(params) {
  return axios.post('/tbBaseCheckItem/add', params, false);
}

// 修改检查项
export function updateItem(params) {
  return axios.post('/tbBaseCheckItem/edit', params, false);
}

// 删除检查项
export function delItem(id) {
  return axios.delete(`/tbBaseCheckItem/${id}`, true)
}
